import versions from '../data/image-versions.json';

/**
 * Appends a cache-busting version to an image path.
 *
 * Encrypted images get a short hash of their own content, written to
 * src/data/image-versions.json by scripts/encrypt-images.mjs: after a deploy,
 * only the images that changed get a new URL, the others stay in the browser
 * cache. A path missing from that map falls back to the build version
 * (REACT_APP_BUILD_VERSION, a unix timestamp injected by
 * scripts/inject-build-version.mjs before each build), new on every deploy.
 *
 * In development (npm start) the build version is undefined, so no suffix is added.
 */
const buildVersion = process.env.REACT_APP_BUILD_VERSION;

export const imgUrl = (path) => {
  if (!buildVersion) return path;
  return `${path}?v=${versions[path] || buildVersion}`;
};
